module.exports = __webpack_public_path__ + "img/olive-post1.6f8e087b.jpg";